// extracted by mini-css-extract-plugin
export default {"title":"NewArticlePage_title__KbxN5","title-class":"NewArticlePage_title-class__vJhnY","title-input":"NewArticlePage_title-input__UKALG","error":"NewArticlePage_error__eJ3dU"};